import React from 'react';
import { Card, CardContent } from '../../ui/Card';

const indicators = [
  ['Publiserte kurs', 'publishedCourses'],
  ['Registrerte kursdeltakere', 'participants'],
  ['Aktive påmeldinger', 'activeEnrollments'],
  ['Fullførte kurs', 'completions'],
  ['Utstedte kursbevis', 'issuedCertificates'],
  ['Pågående kurs', 'ongoingCourses']
];

export function AcademyAdminKpis({ metrics }) {
  return (
    <section
      aria-label="Nøkkeltall for Academy"
      className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3"
    >
      {indicators.map(([label, key], index) => (
        <Card key={key} delay={index * 0.04}>
          <CardContent className="flex items-center justify-between gap-4">
            <div>
              <p className="text-sm font-medium text-slate-500">{label}</p>
              <p className="mt-2 text-3xl font-semibold text-slate-900">
                {metrics[key].toLocaleString('nb-NO')}
              </p>
            </div>
            <span className="h-2.5 w-2.5 rounded-full bg-blue-500" aria-hidden="true" />
          </CardContent>
        </Card>
      ))}
    </section>
  );
}